<template>
  <section id="recentSection" class="breakdown-section my-5 scroll-snap-section">
    <div>
      <h2>Recent Ancestry</h2>
      <p>Your autosomal results show you a view of your ancestry as a puzzle of populations which contribute
        to
        your ancestral profile. This accounts for the general location of your ancestors possibly as far
        back
        as
        1500 years ago?</p>
      <p>As the number of ancestors doubles each generation the further back we go (2 parents, 4
        grandparents,
        8
        great-grandparents and so on) the further in time you go, the lower the autosomal DNA contribution
        from
        each ancestor.</p>
    </div>
    <RecentMapCard :regions="sharingStore.autosomalResult" />
  </section>
</template>
<script setup>
import { useSharingStore } from "@/store/sharing";
const sharingStore = useSharingStore();
import RecentMapCard from '@/view/sharing/RecentMapCard.vue';
</script>